export interface Workflow {
  id: string;
  name: string;
  runId: string;
  status: number;
  startTime: string;
  endTime?: string;
  executionTime: string;
  taskQueue: string;
  isRunning: boolean;
}

export type SortColumn = 'startTime' | 'name' | 'status' | 'duration';
export type SortDirection = 'asc' | 'desc';

export interface WorkflowStatus {
  value: number;
  label: string;
  color: string;
  isRunning?: boolean;
}

export const WORKFLOW_STATUSES: Record<number, WorkflowStatus> = {
  1: { value: 1, label: 'Running', color: 'bg-yellow-100 text-yellow-800' },
  2: { value: 2, label: 'Completed', color: 'bg-green-100 text-green-800' },
  3: { value: 3, label: 'Failed', color: 'bg-red-100 text-red-800' },
};
